import React from 'react';
import { useToast } from '../contexts/ToastContext';
import Toast from './ui/toast';

const ToastContainer: React.FC = () => {
  const { toasts, hideToast } = useToast();

  return (
    <div
      className="fixed top-4 right-4 z-[9999] flex flex-col gap-3 pointer-events-none"
      aria-live="polite"
      aria-atomic="true"
    >
      {toasts.map((toast) => (
        <div key={toast.id} className="pointer-events-auto">
          <Toast
            id={toast.id}
            type={toast.type}
            message={toast.message}
            duration={toast.duration}
            onClose={() => hideToast(toast.id)}
          />
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
